<div
  class="preloader-container"
  [ngClass]="{
    'preloader-container--inverse': inverse,
    'preloader-container--responsive': responsive,
    'preloader-container--inline': inline
  }"
>
  <div
    class="spinner-border my-auto "
    role="status"
    [ngClass]="{
      'spinner-border--inverse': inverse,
      'spinner-border--responsive': responsive
    }"
    [ngStyle]="customStyle"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
</div>